export const todo = {
    namespaced: true,   
    state: {
        todoArray: [],
    },
    actions: {
        getTodoArray({ commit }) {
            commit('getTodoArray')
        },
        setAddTodoArray({ commit }, item) {
            commit('addTodoArray', item)
        },
        setCleanTodoArray({ commit }) {
            commit('cleanTodoArray')
        },
        setDeleteSelected({ commit }, index) {
            commit('deleteTodo', index)            
        },
    },
    mutations: {
        getTodoArray(state) {
            return state.todoArray;
        },
        addTodoArray(state, item) {
            state.todoArray.push(item);
        },
        deleteTodo(state, index) {
            state.todoArray.splice(index, 1);
        },
        cleanTodoArray(state) {
            state.todoArray.length = 0;
        },
    }
};